// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "stylesheets/" + (chunkId === 251 ? "checkout" : chunkId) + "." + {"8":"d33ef2bb230a2bd84d44","251":"b79879a7a3007461bf6e"}[chunkId] + ".css";
};